import type { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import IconWithTooltip from 'app/components/IconWithTooltip';
import csBombIcon from 'app/icons/cs_bomb.svg';
import csDeathIcon from 'app/icons/cs_death.svg';
import csDefuseIcon from 'app/icons/cs_defuse.svg';
import csTimeoutIcon from 'app/icons/cs_timeout.svg';

import style from './style.module.scss';

interface Props extends ClassNameProp {
  side: SideRound;
  type: RoundOutcome | undefined;
}

const videogameFromSide: Record<SideRound, RoundTypeVideogames> = {
  'counter-terrorist': 'cs-go',
  terrorist: 'cs-go'
};

const victoryIconRefs: Record<RoundTypeVideogames, Record<RoundOutcome, SVG>> = {
  'cs-go': {
    defuse: csDefuseIcon,
    death: csDeathIcon,
    bomb: csBombIcon,
    timeout: csTimeoutIcon,
    unknown: () => null
  },
  valorant: {
    defuse: csDefuseIcon,
    death: csDeathIcon,
    bomb: csBombIcon,
    timeout: csTimeoutIcon,
    unknown: () => null
  }
};

const RoundOutcomeIcon: FC<Props> = ({ side, type, className }) => {
  const { t } = useTranslation();

  if (!type) {
    return null;
  }

  const Icon = victoryIconRefs[videogameFromSide[side]][type];

  if (!Icon) {
    return null;
  }

  const label = t(`round_outcome-${type}`);

  return (
    <IconWithTooltip Icon={Icon} label={label} iconClassName={classNames(style[side], className)} />
  );
};

RoundOutcomeIcon.displayName = 'RoundOutcomeIcon';

export default RoundOutcomeIcon;
